import React from 'react';

interface Props {
  error: string;
  onClose: () => void;
}

export function ErrorModal({ error, onClose }: Props) {
  return (
    <div className="admin-modal-overlay" onClick={onClose}>
      <div
        className="admin-modal admin-error-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-error-modal-header">
          <h3 className="admin-error-modal-title">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="currentColor"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
              <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
            </svg>
            Error Details
          </h3>
          <button className="admin-error-modal-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="admin-error-modal-body">
          <pre className="admin-error-text">{error}</pre>
        </div>
      </div>
    </div>
  );
}
